import { Header, Icon, Segment } from "semantic-ui-react";
import React from "react";

export function NoRecords({ iconName, message }) {
  return (
    <Segment placeholder>
      <Header icon size="small">
        <Icon
          name={iconName ? iconName : "warning sign"}
          style={{ color: iconName ? "" : "#ECC600" }}
        />
        {message}
      </Header>
    </Segment>
  );
}
